// PRODUCTION — client-side option filtering for the flow editor dropdown
import type { BasicSelectOption } from 'src/components/shared/form/BasicSelect'

/**
 * Dropdowns at or above this many options render a search field. Production Yardstik
 * package lists run to ~250 entries, which is unusable without one.
 */
export const PROTO_SELECT_SEARCH_THRESHOLD = 10

/**
 * Case-insensitive substring match on the option label. Returns the original array
 * when the query is blank so the caller keeps a stable reference.
 */
export const filterProtoSelectOptions = (
  options: BasicSelectOption[],
  query: string,
): BasicSelectOption[] => {
  const normalizedQuery = query.trim().toLowerCase()

  if (normalizedQuery === '') {
    return options
  }

  return options.filter((option) => {
    return String(option.label).toLowerCase().includes(normalizedQuery)
  })
}
